import { baseGet, basePost } from '@/utils/api/base';
import apiEndPointList from '../constant/apiEndPointsList';
import { get } from 'http';

const galleryServices = {
    getAllAsset: async (idPath: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.gallery.GET_ALL_ASSET(idPath),
            });
        } catch (err) {
            response = err;
        }
        return response.data;
    },

    getGalleriesByType: async (page: number, limit: number, language_id: string, idPath: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.gallery.GET_ASSET_BY_TYPE(page, limit, language_id, idPath),
            });
        } catch (err) {
            response = err;
        }
        return response.data;
    },

    getGalleryById: async (id: string, idPath?: string, languageId?: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.gallery.GET_ASSET_BY_ID(id, idPath, languageId),
            });
        } catch (err) {
            response = err;
        }
        return response.data;
    },

    searchGalleryByTypeAndKeyword: async (keyword: string, language_id: string, idPath: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.gallery.SEARCH_ASSET_BY_TYPE_AND_KEYWORD(keyword, language_id, idPath),
            });
        } catch (err) {
            response = err;
        }
        return response.data;
    },

    getAllAssetWithCategoryByType: async (idPath?: string, language_id?: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.gallery.GET_ALL_ASSET_WITH_CATEGORY_BY_TYPE(idPath, language_id),
            });
        } catch (err) {
            response = err;
        }
        return response.data;
    },
    getAssetByCategory: async (category_id: string, limit: number, page: number, idPath?: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.gallery.GET_ASSET_BY_CATEGORY(category_id, limit, page, idPath),
            });
        } catch (err) {
            response = err;
        }
        return response.data;
    },
    getCategoryGroupByAssetType: async (type: string, language_id: string, idPath?: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.gallery.GET_CATEGORY_GROUP_BY_ASSET_TYPE(type, language_id, idPath),
            });
        } catch (err) {
            response = err;
        }
        return response.data;
    },

    // Fetch related assets (documents, photos, videos) for a model
    getModelRelatedAssets: async (modelUuid: string, languageId: string, idPath: string, assetType: number = 1) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.gallery.GET_MODEL_RELATED_ASSETS(idPath, languageId, modelUuid, assetType, 3),
            });
        } catch (err) {
            response = err;
        }
        return response.data;
    },

    incrementViewCount: async ({ uuid, idPath }: { uuid: string; idPath: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.gallery.INCREMENT_ASSET_VIEW(uuid, idPath),
            });
        } catch (err: any) {
            console.error("Error calling incrementViewCount API for asset:", err);
        }
        return response?.data;
    }
};

export default galleryServices;
